import Page from "flarum/common/components/Page";
import FactViewer from "./FactViewer";
export default class FactBrowsePage extends Page {
  view() {
    const hash = window.location.hash.slice(1);
    const id = /^[1-9]\d{0,8}$/.test(hash) ? Number(hash) : undefined;
    return m(FactViewer, {
      key: id ?? "latest",
      id: id
    });
  }
}
flarum.reg.add('xgay-fact', 'forum/components/FactBrowsePage', FactBrowsePage);